module.exports = __webpack_public_path__ + "img/3.9ba3b4ee.jpg";